import React, { useState } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import toast from "react-hot-toast";
import Spinner from "../../../reusableComponents/spinner/Spinner";
import Select from "react-select";
import { baseUrl } from "../../../utils/axiosInstance";
import customStyles from "../../../customStyles";
import "./SwitchPlatformModal.scss";

const SwitchPlatformModal = ({ isOpen, onClose, item }) => {
    const [selectedPlatform, setSelectedPlatform] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const { idToken } = useSelector((state) => state.auth);

    // Static platform options as requested
    const options = React.useMemo(() => [
        { value: 5, label: "Alpha Trader" },
        { value: 2, label: "Tradovate Prop" },
    ], []);

    React.useEffect(() => {
        if (options.length > 0 && !selectedPlatform) {
            const defaultPlatform = options.find(p => p.label === "Alpha Trader");
            if (defaultPlatform) {
                setSelectedPlatform(defaultPlatform);
            }
        }
    }, [options, selectedPlatform]);

    const handleSwitch = async () => {
        if (!selectedPlatform) {
            toast.error("Please select a platform.");
            return;
        }

        setIsLoading(true);
        try {
            const payload = {
                new_platform: selectedPlatform.value,
                login_id: item?.login_id || item?.user_name
            };

            const res = await axios.post(`${baseUrl}account/switch-platform/`, payload, {
                headers: {
                    Authorization: `Bearer ${idToken}`,
                },
            });

            toast.success(res.data.detail || "Platform switch request submitted successfully.");
            onClose();
        } catch (error) {
            toast.error(error.response?.data?.detail || "Failed to switch platform.");
        } finally {
            setIsLoading(false);
        }
    };

    const getPlatformMessage = () => {
        if (selectedPlatform?.value === 5) { // Alpha Trader
            return "Our team has been working tirelessly around the clock to bring our traders their new favorite platform, Alpha Trader. It is not quite ready yet, but we want to give you the option to be one of the first users on it once available (up to one week).";
        }
        if (selectedPlatform?.value === 2) { // Tradovate Prop
            return "If you would rather continue with Tradovate Prop, we will get you transferred over in the same business day. Thank you for trading with us!";
        }
        return "Please select a platform to proceed.";
    };

    if (!isOpen) return null;

    return (
        <div className="switch-platform-modal-overlay">
            <div className="switch-platform-modal-container">
                <div className="modal-header">
                    <p>Switch Platform</p>
                    <span onClick={onClose}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <circle cx="12" cy="12" r="8.4" stroke="white" strokeWidth="1.2" />
                            <path d="M16 8L8 16" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M8 8L16 16" stroke="white" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    </span>
                </div>

                <div className="modal-body">
                    <p className="description">
                        Select a new platform for <strong>{item?.account_name}</strong>
                    </p>

                    <div className="platform-selection-container">
                        {/* <div className="platform-message">
                            <p>{getPlatformMessage()}</p>
                        </div> */}
                        <div className="platform-selector">
                            <Select
                                className="react-select-container"
                                classNamePrefix="react-select"
                                value={selectedPlatform}
                                onChange={setSelectedPlatform}
                                options={options}
                                placeholder="Select platform"
                                styles={customStyles}
                            />
                            <div className="submit-btn-container">
                                <button
                                    className="standard-button"
                                    style={{ width: "100%", padding: "12px" }}
                                    onClick={handleSwitch}
                                    disabled={isLoading}
                                >
                                    {isLoading ? <Spinner size={20} /> : "Switch Platform"}
                                </button>
                            </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    );
};

export default SwitchPlatformModal;
